import { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import { exists } from '@utils/functions.js'

export default class NavItem extends Component {
  static propTypes = {
    label: PropTypes.string,
    className: PropTypes.string,
    active: PropTypes.bool,
    options: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.shape({
        anchor: PropTypes.string,
      }),
    ]),
    onClickArgs: PropTypes.array,
    onClick: PropTypes.func,
  }

  static defaultProps = {
    label: '',
    className: 'tabbed-nav__list-item',
    active: false,
    options: '#',
    onClick: null,
    onClickArgs: null,
  }

  handleClick = event => {
    const { onClickArgs, onClick } = this.props
    if (onClick) {
      event.preventDefault()
      onClick(onClickArgs)
    }
  }

  // Note: Rails is smart enough to use either a string or options hash to construct the href, so we need to potentially deal with anchors here too
  getHref() {
    const { options } = this.props
    switch (typeof options) {
      case 'string':
        return options

      case 'object':
        if (exists(options) && exists(options.anchor)) {
          return `#${options.anchor}`
        }
    }
    return '#'
  }

  getLabelContent() {
    const { label, raw_html_label } = this.props
    let content = null
    if (raw_html_label) {
      content = <span dangerouslySetInnerHTML={{ __html: raw_html_label }} />
    } else {
      content = <span>{label}</span>
    }
    return content
  }

  render() {
    const { active, className } = this.props

    const labelContent = this.getLabelContent()
    const classes = classnames(className, {
      current: active,
    })
    const href = this.getHref()
    return (
      <li className={classes}>
        <a href={href} onClick={this.handleClick} data-testid="qa-nav-item-anchor">
          {labelContent}
        </a>
      </li>
    )
  }
}
